import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    // Disabled auto-open to prevent theme drawer from opening
    // if (this.hasAttribute('auto-open')) {
    //   this.showDialog();
    // }
  };

  open() {
    // Disabled theme drawer opening
    // this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked
     * (Disabled because drawer no longer opens)
     */
    // customElements.whenDefined('shopify-payment-terms').then(() => {
    //   const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
    //   const cta = installmentsContent?.querySelector('#shopify-installments-cta');
    //   cta?.addEventListener('click', this.closeDialog, { once: true });
    // });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
